import { useNavigate } from 'react-router-dom';
import Button from './Button';

interface PricingCardProps {
  title: string | undefined;
  content: string | undefined;
  packages: string | undefined;
  price: string;
  className?: string;
}

const PricingCard = ({
  title,
  content,
  packages,
  price,
  className,
}: PricingCardProps) => {
  const navigate = useNavigate();

  const toOrder = () => {
    navigate('/order');
  };

  return (
    <div
      className={`mt-4 flex h-[343px] w-[343px] flex-col justify-between rounded-xl p-6 lg:h-[428px] lg:w-[359px] lg:p-8 ${className}`}
    >
      <p className="text-2xl font-bold text-primary-blue lg:text-3xl">
        {title}
      </p>
      <p className="text-sm font-normal text-primary-grey lg:text-base">
        {content}
      </p>
      <p className="text-base font-bold text-primary-light-blue lg:text-xl">
        {packages}
      </p>
      <p className="text-4xl font-extrabold text-primary-blue lg:text-[40px] lg:leading-relaxed">
        {price} CHF
      </p>
      {/*<Button theme="OUTLINE" className="bg-white" onClick={toOrder}>
        <p className="font-semibold">Select plan</p>
  </Button>*/}
    </div>
  );
};

export default PricingCard;
